/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderItemUpdateDto } from './OrderItemUpdateDto';
import {
    OrderItemUpdateDtoFromJSON,
    OrderItemUpdateDtoFromJSONTyped,
    OrderItemUpdateDtoToJSON,
} from './OrderItemUpdateDto';

/**
 * 
 * @export
 * @interface AdminUpdateOrderDto
 */
export interface AdminUpdateOrderDto {
    /**
     * Order status
     * @type {number}
     * @memberof AdminUpdateOrderDto
     */
    status: number;
    /**
     * Timestamp at which the order is expected to be delivered
     * @type {Date}
     * @memberof AdminUpdateOrderDto
     */
    estDeliveryAt: Date;
    /**
     * Updated order items
     * @type {Array<OrderItemUpdateDto>}
     * @memberof AdminUpdateOrderDto
     */
    items?: Array<OrderItemUpdateDto>;
}

/**
 * Check if a given object implements the AdminUpdateOrderDto interface.
 */
export function instanceOfAdminUpdateOrderDto(value: object): value is AdminUpdateOrderDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('estDeliveryAt' in value) || value['estDeliveryAt'] === undefined) return false;
    return true;
}

export function AdminUpdateOrderDtoFromJSON(json: any): AdminUpdateOrderDto {
    return AdminUpdateOrderDtoFromJSONTyped(json, false);
}

export function AdminUpdateOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'estDeliveryAt': (new Date(json['estDeliveryAt'])),
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(OrderItemUpdateDtoFromJSON)),
    };
}

export function AdminUpdateOrderDtoToJSON(value?: AdminUpdateOrderDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'estDeliveryAt': ((value['estDeliveryAt']).toISOString()),
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(OrderItemUpdateDtoToJSON)),
    };
}

